module.exports = __webpack_public_path__ + "media/country_flags/mv-8470d0ea.png";